import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
import React from "react";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig";
import { donationsUrl } from "../donationsUrl";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { AppProps } from "common/lib/getAppServerSideProps";
const FAKE_BUTTON_STYLING = clsx("min-hitbox-44 box-border inline-block max-w-40 grow items-center rounded-full p-2 sm:hidden lg:px-5 lg:py-2", "text-center text-xs font-bold text-white visited:text-white hover:text-white");
export const ActionButtons = () => {
  "use memo";

  const $ = _c(13);
  const t = useTranslations("layout.header");
  const {
    regionCode
  } = usePageProps();
  const regionConfig = useRegionConfig();
  const {
    stay_informed,
    donations
  } = regionConfig;
  let t0;
  if ($[0] !== donations.enabled || $[1] !== donations.promoted || $[2] !== regionCode || $[3] !== regionConfig || $[4] !== t) {
    t0 = donations.enabled && !donations.promoted && <a href={donationsUrl({
      regionConfig,
      regionCode,
      campaign: "mobile-menu"
    })} className={clsx(FAKE_BUTTON_STYLING, "bg-red-600 hover:bg-red-500")}>{t("donate")}</a>;
    $[0] = donations.enabled;
    $[1] = donations.promoted;
    $[2] = regionCode;
    $[3] = regionConfig;
    $[4] = t;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== donations.promoted || $[7] !== stay_informed || $[8] !== t) {
    t1 = donations.promoted && stay_informed.enabled && <a href={stay_informed.topbar.url} className={clsx(FAKE_BUTTON_STYLING, "bg-black hover:bg-black")}>{t("get_newsletter")}</a>;
    $[6] = donations.promoted;
    $[7] = stay_informed;
    $[8] = t;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== t0 || $[11] !== t1) {
    t2 = <div className="m-4 flex">{t0}{t1}</div>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};